import _ from "lodash";
import { createSelector } from "reselect";
import { getInitials, getVenuePrimaryPhotoUrl } from "sweet-global";
import { RootState } from "sweet-web/redux";
import { userType } from "./user";
import { images } from "sweet-assets";

const s = (state: RootState) => state.chat;

export const chats = (state: RootState) => s(state).chats;
export const archivedChats = (state: RootState) => s(state).archivedChats;
export const chatIds = (state: RootState) =>
  typeof chats(state) === "object" ? Object.keys(chats(state)) : null;
export const chatUsers = (state: RootState) => s(state).chatUsers;
export const chatVenues = (state: RootState) => s(state).chatVenues;
export const chatMessages = (state: RootState) => s(state).chatMessages;
export const isCreatingChat = (state: RootState) => s(state).isCreatingChat;

export const chat = (id: string) =>
  createSelector(chats, chatsState => (chatsState ? chatsState[id] : null));

export const messages = (chatId: string) =>
  createSelector(chatMessages, chatMessagesState =>
    chatMessagesState ? chatMessagesState[chatId] : {}
  );

export const chatUser = (chatId: string) =>
  createSelector(chat(chatId), chatUsers, (chatValue, chatUsersValue) =>
    chatUsersValue && chatValue ? chatUsersValue[chatValue.user] : null
  );

export const chatVenue = (chatId: string) =>
  createSelector(chat(chatId), chatVenues, (chatValue, chatVenuesValue) =>
    chatValue && chatVenuesValue ? chatVenuesValue[chatValue.venue] : null
  );

export const otherChatUserName = (chatId: string) =>
  createSelector(
    userType,
    chat(chatId),
    chatUser(chatId),
    chatVenue(chatId),
    (userTypeValue, chatValue, chatUserValue, chatVenueValue) => {
      if (chatValue.sweet === true && userTypeValue !== "ADMIN") {
        return "Sweet Support";
      } else if (userTypeValue !== "USER" && chatUserValue) {
        return `${chatUserValue.firstName} ${chatUserValue.lastName}`;
      } else if (userTypeValue !== "VENUE" && chatVenueValue) {
        return chatVenueValue.name;
      } else return null;
    }
  );

export const otherChatUserImage = (chatId: string) =>
  createSelector(
    userType,
    chat(chatId),
    chatUser(chatId),
    chatVenue(chatId),
    (userTypeValue, chatValue, chatUserValue, chatVenueValue) => {
      if (chatValue.sweet === true && userTypeValue !== "ADMIN") {
        return images.brand.logo;
      } else if (userTypeValue !== "USER" && chatUserValue) {
        return chatUserValue.image;
      } else if (userTypeValue !== "VENUE" && chatVenueValue) {
        return getVenuePrimaryPhotoUrl(chatVenueValue);
      } else return null;
    }
  );

export const otherChatUserType = (chatId: string) =>
  createSelector(chatUser(chatId), chatUserValue => {
    return chatUserValue.type;
  });

export const otherChatUserInitials = (chatId: string) =>
  createSelector(
    userType,
    chat(chatId),
    chatUser(chatId),
    chatVenue(chatId),
    (userTypeValue, chatValue, chatUserValue, chatVenueValue) => {
      if (chatValue.sweet === true && userTypeValue !== "ADMIN") {
        return images.brand.logo;
      } else if (userTypeValue !== "USER" && chatUserValue) {
        return getInitials(
          `${chatUserValue.firstName} ${chatUserValue.lastName}`
        );
      } else if (userTypeValue === "USER" && chatVenueValue) {
        return getInitials(chatVenueValue.name);
      } else return null;
    }
  );
